/* vue-kerlink version 3.0.3 */
import BModal from 'bootstrap-vue/es/components/modal/modal';

//

var script = {
  components: { BModal },

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    // Id to...identify modal
    id: {
      type: String,
      required: true
    },
    // Title of the modal
    title: {
      type: String,
      default: ''
    },
    // Size of the modal
    // lg: large modal
    // md: medium modal (default)
    // sm: small modal
    size: {
      type: String,
      default: 'md'
    },
    // Hide footer, to use custom buttons for a wizard modal for instance
    // ⚠️ When using custom buttons:
    //    - no modal-cancel event will be emitted when pressing cancel button, you will need to manage it in the parent
    //    - no collback function can be used
    noFooter: {
      type: Boolean,
      default: false
    },
    // Callback executed on validate button click
    // Only a close button if no callback provided
    // ⚠️ The callback function needs to close the modal by setting v-model to false.
    //    This way, you can close modal when you want (after form validation for instance)
    callback: {
      type: Function,
      default: null
    },
    // Display or hide modal
    // To be used as v-model
    show: {
      type: Boolean,
      required: true
    },
    // Disable validate buttons to prevent multiple validation
    // Needs to be reset to false by the parent when hidding modal
    disableValidateButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      // Display or hide b-modal
      // Needed as it is a wrapper around b-modal
      // It cannot change our props, so we need another variable
      visible: false
    }
  },

  watch: {
    // Synchronize show and visible
    // Use change event to update v-model
    show () {
      this.visible = this.show;
    },
    visible () {
      this.$emit('change', this.visible);
    }
  },

  methods: {
    // always emits just before modal is shown. cancelable
    showEvt () {
      this.$emit('modal:show');
    },
    // always emits when modal is shown
    shownEvt () {
      this.$emit('modal:shown');
    },
    // always emits just before modal has hidden
    hideEvt (evt) {
      this.$emit('modal:hide');
      if (evt.trigger === 'esc' || evt.trigger === 'backdrop') this.$emit('modal:cancel');
    },
    // always emits after modal is hidden
    hiddenEvt () {
      this.$emit('modal:hidden');
    },
    // cancel modal
    cancel () {
      this.visible = false;
      this.$emit('modal:cancel');
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        size: _vm.size,
        "hide-header-close": true,
        "no-close-on-backdrop": ""
      },
      on: {
        show: _vm.showEvt,
        shown: _vm.shownEvt,
        hide: _vm.hideEvt,
        hidden: _vm.hiddenEvt
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v;
        },
        expression: "visible"
      }
    },
    [
      _c(
        "template",
        { slot: "modal-header" },
        [
          _c("h4", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")(_vm.title)))
          ]),
          _vm._v(" "),
          _vm._t("modal-header-right")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("modal-body"),
      _vm._v(" "),
      _c(
        "template",
        { slot: "modal-footer" },
        [
          _vm.noFooter
            ? _vm._t("modal-footer")
            : [
                _vm.callback
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-flat",
                        attrs: { id: _vm.id + "-cancel" },
                        on: {
                          click: function($event) {
                            $event.preventDefault();
                            return _vm.cancel($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm._f("capitalize")("Cancel")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.callback
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-flat",
                        attrs: {
                          id: _vm.id + "-validate",
                          disabled: _vm.disableValidateButton
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault();
                            return _vm.callback($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm._f("capitalize")("Validate")))]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-flat",
                        on: {
                          click: function($event) {
                            $event.preventDefault();
                            _vm.visible = false;
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm._f("capitalize")("Close")))]
                    )
              ]
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5dc6d624_0", { source: ".modal-dialog {\n  /* When the modal fills the screen it has an even 2.5% on top and bottom */\n  /* Centers the modal */\n  margin: 2.5vh auto;\n}\n.modal-dialog .modal-content {\n  /* Sets the maximum height of the entire modal to 95% of the screen height */\n  max-height: 95vh;\n}\n.modal-dialog .modal-content .modal-header {\n  height: 62px;\n  border-bottom: none;\n}\n.modal-dialog .modal-content .modal-header .modal-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.modal-dialog .modal-content .modal-header input {\n  width: 100px;\n  transition: width 0.35s;\n}\n.modal-dialog .modal-content .modal-header input:focus {\n  width: 200px;\n}\n.modal-dialog .modal-content .modal-body {\n  /* Body height will take all content height minus header and footer */\n  max-height: calc(95vh - 62px - 66px);\n  overflow-y: auto;\n}\n.modal-dialog .modal-content .modal-body pre {\n  max-height: none;\n}\n.modal-dialog .modal-content .modal-footer {\n  height: 66px;\n  border-top: none;\n}\n.modal-dialog.modal-lg .modal-content .modal-header input:focus {\n  width: 250px;\n}\n\n/*# sourceMappingURL=Modal.vue.map */", map: {"version":3,"sources":["C:\\Users\\alg\\Workspace_Dashboard\\vue-kerlink\\src\\components\\Modal.vue","Modal.vue"],"names":[],"mappings":"AAgJA;EACA,0EAAA;EAEA,sBAAA;EACA,kBAAA;AChJA;ADkJA;EACA,4EAAA;EACA,gBAZA;ACpIA;ADkJA;EACA,YAdA;EAeA,mBAAA;AChJA;ADkJA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AChJA;ADmJA;EACA,YAAA;EACA,uBAAA;ACjJA;ADmJA;EACA,YAAA;ACjJA;ADsJA;EACA,qEAAA;EACA,oCAAA;EACA,gBAAA;ACpJA;ADsJA;EACA,gBAAA;ACpJA;ADwJA;EACA,YA3CA;EA4CA,gBAAA;ACtJA;AD6JA;EACA,YAAA;AC3JA;;AAEA,oCAAoC","file":"Modal.vue","sourcesContent":["<template>\n  <b-modal :id=\"id\"\n           v-model=\"visible\"\n           :size=\"size\"\n           :hide-header-close=\"true\"\n           no-close-on-backdrop\n           @show=\"showEvt\"\n           @shown=\"shownEvt\"\n           @hide=\"hideEvt\"\n           @hidden=\"hiddenEvt\"\n  >\n    <template slot=\"modal-header\">\n      <h4 class=\"modal-title\">{{ title | capitalize }}</h4>\n      <slot name=\"modal-header-right\" />\n    </template>\n\n    <slot name=\"modal-body\" />\n\n    <template slot=\"modal-footer\">\n      <slot v-if=\"noFooter\" name=\"modal-footer\" />\n\n      <template v-else>\n        <button v-if=\"callback\" :id=\"id + '-cancel'\" class=\"btn btn-flat\" @click.prevent=\"cancel\">{{ 'Cancel' | capitalize }}</button>\n        <button v-if=\"callback\" :id=\"id + '-validate'\" :disabled=\"disableValidateButton\" class=\"btn btn-flat\" @click.prevent=\"callback\">{{ 'Validate' | capitalize }}</button>\n        <button v-else class=\"btn btn-flat\" @click.prevent=\"visible=false\">{{ 'Close' | capitalize }}</button>\n      </template>\n    </template>\n  </b-modal>\n</template>\n\n<script>\nimport BModal from 'bootstrap-vue/es/components/modal/modal'\n\nexport default {\n  components: { BModal },\n\n  model: {\n    prop: 'show',\n    event: 'change'\n  },\n\n  props: {\n    // Id to...identify modal\n    id: {\n      type: String,\n      required: true\n    },\n    // Title of the modal\n    title: {\n      type: String,\n      default: ''\n    },\n    // Size of the modal\n    // lg: large modal\n    // md: medium modal (default)\n    // sm: small modal\n    size: {\n      type: String,\n      default: 'md'\n    },\n    // Hide footer, to use custom buttons for a wizard modal for instance\n    // ⚠️ When using custom buttons:\n    //    - no modal-cancel event will be emitted when pressing cancel button, you will need to manage it in the parent\n    //    - no collback function can be used\n    noFooter: {\n      type: Boolean,\n      default: false\n    },\n    // Callback executed on validate button click\n    // Only a close button if no callback provided\n    // ⚠️ The callback function needs to close the modal by setting v-model to false.\n    //    This way, you can close modal when you want (after form validation for instance)\n    callback: {\n      type: Function,\n      default: null\n    },\n    // Display or hide modal\n    // To be used as v-model\n    show: {\n      type: Boolean,\n      required: true\n    },\n    // Disable validate buttons to prevent multiple validation\n    // Needs to be reset to false by the parent when hidding modal\n    disableValidateButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      // Display or hide b-modal\n      // Needed as it is a wrapper around b-modal\n      // It cannot change our props, so we need another variable\n      visible: false\n    }\n  },\n\n  watch: {\n    // Synchronize show and visible\n    // Use change event to update v-model\n    show () {\n      this.visible = this.show\n    },\n    visible () {\n      this.$emit('change', this.visible)\n    }\n  },\n\n  methods: {\n    // always emits just before modal is shown. cancelable\n    showEvt () {\n      this.$emit('modal:show')\n    },\n    // always emits when modal is shown\n    shownEvt () {\n      this.$emit('modal:shown')\n    },\n    // always emits just before modal has hidden\n    hideEvt (evt) {\n      this.$emit('modal:hide')\n      if (evt.trigger === 'esc' || evt.trigger === 'backdrop') this.$emit('modal:cancel')\n    },\n    // always emits after modal is hidden\n    hiddenEvt () {\n      this.$emit('modal:hidden')\n    },\n    // cancel modal\n    cancel () {\n      this.visible = false\n      this.$emit('modal:cancel')\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n  @import \"../scss/variables\";\n\n  $content-mheight: 95vh;\n  $header-height: 62px;\n  $footer-height: 66px;\n\n  .modal-dialog {\n    /* When the modal fills the screen it has an even 2.5% on top and bottom */\n\n    /* Centers the modal */\n    margin: 2.5vh auto;\n\n    .modal-content {\n      /* Sets the maximum height of the entire modal to 95% of the screen height */\n      max-height: $content-mheight;\n\n      .modal-header {\n        height: $header-height;\n        border-bottom: none;\n\n        .modal-title {\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n\n        input {\n          width: 100px;\n          transition: width 0.35s;\n\n          &:focus {\n            width: 200px;\n          }\n        }\n      }\n\n      .modal-body {\n        /* Body height will take all content height minus header and footer */\n        max-height: calc(#{$content-mheight} - #{$header-height} - #{$footer-height});\n        overflow-y: auto;\n\n        pre {\n          max-height: none;\n        }\n      }\n\n      .modal-footer {\n        height: $footer-height;\n        border-top: none;\n      }\n    }\n\n    &.modal-lg .modal-content {\n      .modal-header {\n        input {\n          &:focus {\n            width: 250px;\n          }\n        }\n      }\n    }\n  }\n</style>\n",".modal-dialog {\n  /* When the modal fills the screen it has an even 2.5% on top and bottom */\n  /* Centers the modal */\n  margin: 2.5vh auto;\n}\n.modal-dialog .modal-content {\n  /* Sets the maximum height of the entire modal to 95% of the screen height */\n  max-height: 95vh;\n}\n.modal-dialog .modal-content .modal-header {\n  height: 62px;\n  border-bottom: none;\n}\n.modal-dialog .modal-content .modal-header .modal-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.modal-dialog .modal-content .modal-header input {\n  width: 100px;\n  transition: width 0.35s;\n}\n.modal-dialog .modal-content .modal-header input:focus {\n  width: 200px;\n}\n.modal-dialog .modal-content .modal-body {\n  /* Body height will take all content height minus header and footer */\n  max-height: calc(95vh - 62px - 66px);\n  overflow-y: auto;\n}\n.modal-dialog .modal-content .modal-body pre {\n  max-height: none;\n}\n.modal-dialog .modal-content .modal-footer {\n  height: 66px;\n  border-top: none;\n}\n.modal-dialog.modal-lg .modal-content .modal-header input:focus {\n  width: 250px;\n}\n\n/*# sourceMappingURL=Modal.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var Modal = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

export default Modal;
